import axios from "axios";
import { Box, Form, Popup, TabPanel, Toolbar } from "devextreme-react";
import { Label } from "devextreme-react/bar-gauge";
import {
  AsyncRule,
  ButtonItem,
  ColCountByScreen,
  EmailRule,
  GroupItem,
  RequiredRule,
  SimpleItem,
} from "devextreme-react/form";
import { Item } from "devextreme-react/toolbar";
import DataSource from "devextreme/data/data_source";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { hasPermission } from "../../utils/hasPermission";
import { PERM } from "../../utils/permissions";
import { getDateStringFromResintRegNo } from "../common/date";
import ExmployeeInfo from "../Organization/List/EmployeeInfo";
import BasicInformationItem from "./BasicInformationItem";
import {
  cmSvcList,
  dcDivList,
  maritalStatusList,
  militaryCatList,
  sexList,
} from "./data";
import TwoDateBoxComponent from "./TwoDateBoxComponent";
import TwoTextBoxComponent from "./TwoTextBoxComponent";

export default function BasicInformation(props) {
  const { userInfo } = props;

  const [dataSource, setDataSource] = useState(null);
  const [formDataSource, setFormDataSource] = useState(null);
  const [popupVisible, setPopupVisible] = useState(false);

  const [militaryCatDataSource, setMilitaryCatDataSource] = useState(null);
  const [dcDivDataSource, setDcDivDataSource] = useState(null);

  // const userInfo = useSelector((state) => state.userInfo);
  const loginUserInfo = useSelector((state) => state.userInfo);
  const canEditEmp = hasPermission(loginUserInfo.permissions, PERM.ORG_EMP_EDIT);

  const basicInformationFormRef = useRef(null);

  useEffect(async () => {
    setMilitaryCatDataSource(
      new DataSource({
        store: militaryCatList,
        type: "array",
        key: "id",
      })
    );

    setDcDivDataSource(
      new DataSource({
        store: dcDivList,
        type: "array",
        key: "id",
      })
    );
  }, []);

  useEffect(() => {
    setSetDataSource();
  }, [userInfo.employeeNo]);

  useEffect(() => {
    if (
      formDataSource &&
      formDataSource.enFirstName &&
      formDataSource.enLastName
    ) {
      setFormDataSource((prevState) => ({
        ...prevState,
        email: `${formDataSource.enFirstName.toLowerCase()}.${formDataSource.enLastName.toLowerCase()}@beccocro.com`,
      }));
    }
  }, [
    formDataSource && formDataSource.enFirstName,
    formDataSource && formDataSource.enLastName,
  ]);

  const setSetDataSource = async () => {
    if (userInfo.employeeNo) {
      const result = await axios.get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/basicInfo/${userInfo.employeeNo}`
      );

      if (result.data[0].resintRegNo) {
        result.data[0].dob = getDateStringFromResintRegNo(
          result.data[0].resintRegNo
        );
      }

      setDataSource(result.data);
    }
  };

  const itemTitleRender = (data) => {
    return <span>{data.id}</span>;
  };

  const onHiding = () => {
    setPopupVisible(false);
  };

  const onCustomMilitaryCatItemCreating = (args) => {
    if (!args.text) {
      args.customItem = null;
      return;
    }

    const militaryCatIds = militaryCatDataSource.items().map((item) => item.id);
    const incrementedId = Math.max.apply(null, militaryCatIds) + 1;
    const newMilitaryCat = {
      id: "9",
      // id: incrementedId,
      name: args.text,
    };

    args.customItem = militaryCatDataSource
      .store()
      .insert(newMilitaryCat)
      .then(() => {
        militaryCatDataSource.load();
      })
      .then(() => newMilitaryCat)
      .catch((error) => {
        throw error;
      });
  };

  const onCustomDcDivItemCreating = (args) => {
    if (!args.text) {
      args.customItem = null;
      return;
    }

    const newDcDiv = {
      id: "9",
      name: args.text,
    };

    // const count = dcDivDataSource.items().length;

    args.customItem = dcDivDataSource
      .store()
      .insert(newDcDiv)
      .then(() => {
        dcDivDataSource.load();
      })
      .then(() => newDcDiv)
      .catch((error) => {
        throw error;
      });
  };

  const onClick = async () => {
    if (
      basicInformationFormRef.current.instance.validate().isValid &&
      formDataSource.firstName &&
      formDataSource.lastName
    ) {
      delete formDataSource.id;

      let otrMilitaryCat = null;
      let otrDcDiv = null;

      if (formDataSource.militaryCat == "9") {
        const otherItem = militaryCatDataSource
          .items()
          .find((item) => item.id == "9");

        otrMilitaryCat = otherItem
          ? otherItem.name
          : formDataSource.otrMilitaryCat;
      }

      if (formDataSource.dcDiv == "9") {
        const otherItem = dcDivDataSource
          .items()
          .find((item) => item.id == "9");

        otrDcDiv = otherItem ? otherItem.name : formDataSource.otrDcDiv;
      }

      await axios.put(
        `${process.env.REACT_APP_BECCO_API_URL}/api/employee/${formDataSource.employeeNo}`,
        {
          ...formDataSource,
          name: `${formDataSource.lastName}${formDataSource.firstName}`,
          otrMilitaryCat: otrMilitaryCat,
          // formDataSource.militaryCat == "9"
          //   ? militaryCatDataSource.items().find((item) => item.id == "9")
          //       .name
          //   : null,
          otrDcDiv: otrDcDiv,
          // formDataSource.dcDiv == "9"
          //   ? dcDivDataSource.items().find((item) => item.id == "9").name
          //   : null,
        }
      );

      setPopupVisible(false);

      setSetDataSource();
    }
  };

  const validationCallbackEmail = async (params) => {
    const result = await axios.get(
      `${process.env.REACT_APP_BECCO_API_URL}/api/employee/hasEmployee/${formDataSource.employeeNo}?email=${params.value}`
    );

    return result.data.nEmployeeNo == 0;
  };

  const onSexValueChanged = (data) => {
    if (data.value) {
      setFormDataSource((prevState) => ({
        ...prevState,
        sex: data.value,
      }));
    }
  };

  const onValueChanged = (data) => {
    if (data.value) {
      setFormDataSource((prevState) => ({
        ...prevState,
        // dob: `${year}-${month}-${day}`,
        dob: getDateStringFromResintRegNo(data.value),
      }));
    }
  };

  const displayMilitaryCatExpr = (item) => {
    if (item) {
      if (item == "9" || item.id == "9") {
        if (formDataSource.otrMilitaryCat) {
          return formDataSource.otrMilitaryCat;
        } else {
          return item.name;
        }
      } else {
        return item.name;
      }
    }

    return null;
  };

  const displayDcDivExpr = (item) => {
    if (item) {
      if (item == "9" || item.id == "9") {
        if (formDataSource.otrDcDiv) {
          return formDataSource.otrDcDiv;
        } else {
          return item.name;
        }
      } else {
        return item.name;
      }
    }
  };

  return (
    <React.Fragment>
      <Toolbar>
        <Item location={"before"}>
          <span
            style={{ fontWeight: 500, color: "#009688", marginLeft: "10px" }}
          >
            BASIC INFORMATION
          </span>
        </Item>
        {(canEditEmp || userInfo.employeeNo == loginUserInfo.employeeNo) && (
          <Item
            location="after"
            locateInMenu="auto"
            widget="dxButton"
            options={{
              icon: "edit",
              onClick: () => {
                setPopupVisible(true);
                setFormDataSource({
                  ...dataSource[0],
                  ...dataSource[1],
                });

                if (dataSource[0].sex == "1") {
                  setFormDataSource((prevState) => ({
                    ...prevState,
                    ...dataSource[2],
                  }));
                }
              },
            }}
          />
        )}
      </Toolbar>
      <Box direction="row" width={"100%"} height={200}>
        <Item ratio={1}>
          {dataSource && (
            <div className="employeeInfo">
              <ExmployeeInfo
                currentEmployee={dataSource[0]}
                className={"aboutWithoutPhoneEmail"}
              />
            </div>
          )}
        </Item>
        <Item ratio={9}>
          <TabPanel
            height={260}
            dataSource={dataSource}
            loop={true}
            itemTitleRender={itemTitleRender}
            itemComponent={BasicInformationItem}
            animationEnabled={true}
            swipeEnabled={true}
          />
        </Item>
      </Box>
      <Popup
        visible={popupVisible}
        dragEnabled={false}
        hideOnOutsideClick={true}
        showCloseButton={true}
        width={1200}
        height="auto"
        title="BASIC INFO."
        onHiding={onHiding}
      >
        <Form
          ref={basicInformationFormRef}
          labelMode="outside"
          showCloseButton={false}
          labelLocation={"top"}
          minColWidth={300}
          colCount={1}
          //   colCountByScreen={{ sm: 2, md: 4 }}
          //   screenByWidth={(width) => {
          //     return width < 720 ? "sm" : "md";
          //   }}
          validationGroup="basicInformationGroup"
          height={"100%"}
          formData={formDataSource}
        >
          <GroupItem caption={"PROFILE"} colCount={4}>
            <ColCountByScreen sm={2} md={4} />
            <SimpleItem
              dataField={"employeeNo"}
              editorType="dxTextBox"
              editorOptions={{ readOnly: true }}
            >
              {/* <Label text="사번" /> */}
              <Label text="Employee ID" />
            </SimpleItem>
            <SimpleItem>
              {/* <Label text="성명" /> */}
              <Label text="Name" />
              <TwoTextBoxComponent
                firstTextBox={{
                  // placeholder: "성",
                  placeholder: "Last",
                  field: "lastName",
                  value: formDataSource ? formDataSource.lastName : null,
                  requiredRuleMessage: "* Last name is required.",
                }}
                secondTextBox={{
                  // placeholder: "이름",
                  placeholder: "First",
                  field: "firstName",
                  value: formDataSource ? formDataSource.firstName : null,
                  requiredRuleMessage: "* First name is required.",
                }}
                setFormDataSource={setFormDataSource}
              />
            </SimpleItem>
            <SimpleItem>
              {/* <Label text="영문명" /> */}
              <Label text="English Name" />
              <TwoTextBoxComponent
                firstTextBox={{
                  // placeholder: "이름",
                  placeholder: "First",
                  field: "enFirstName",
                  value: formDataSource ? formDataSource.enFirstName : null,
                }}
                secondTextBox={{
                  // placeholder: "성",
                  placeholder: "Last",
                  field: "enLastName",
                  value: formDataSource ? formDataSource.enLastName : null,
                }}
                setFormDataSource={setFormDataSource}
              />
            </SimpleItem>
            <SimpleItem
              dataField={"nickName"}
              editorType="dxTextBox"
              editorOptions={{
                showClearButton: true,
              }}
            >
              {/* <Label text="닉네임" /> */}
              <Label text="Nickname" />
            </SimpleItem>
            <SimpleItem
              dataField={"addr"}
              editorType="dxTextBox"
              editorOptions={{
                showClearButton: true,
              }}
            >
              {/* <Label text="주소" /> */}
              <Label text="Address" />
            </SimpleItem>
            <SimpleItem
              dataField={"detsAddr"}
              editorType="dxTextBox"
              editorOptions={{
                showClearButton: true,
              }}
            >
              {/* <Label text="상세주소" /> */}
              <Label text="Detailed Address" />
            </SimpleItem>
            <SimpleItem
              dataField={"mob"}
              editorType="dxTextBox"
              editorOptions={{
                showClearButton: true,
                mask: "\\01\\0-0000-0000",
              }}
            >
              {/* <Label text="휴대전화" /> */}
              <Label text="Mobile Phone Number" />
              {/* <RequiredRule message={"* 휴대전화를 입력해주세요."} /> */}
              <RequiredRule message={"* Mobile phone number is required."} />
            </SimpleItem>
            <SimpleItem
              dataField={"extNo"}
              editorType="dxTextBox"
              editorOptions={{
                showClearButton: true,
              }}
            >
              {/* <Label text="내선번호" /> */}
              <Label text="Extension Number" />
            </SimpleItem>
            <SimpleItem
              dataField={"email"}
              editorType="dxTextBox"
              editorOptions={{
                showClearButton: true,
              }}
            >
              {/* <Label text="이메일" /> */}
              <Label text="Email (Company Email)" />
              <EmailRule message={"Email is invalid."} />
              <AsyncRule
                message={"Email is already registered."}
                validationCallback={validationCallbackEmail}
              />
            </SimpleItem>
            <SimpleItem
              dataField={"persEmail"}
              editorType="dxTextBox"
              editorOptions={{
                showClearButton: true,
              }}
            >
              {/* <Label text="이메일 (개인)" /> */}
              <Label text="Email (Personal Email)" />
              <EmailRule message={"Email is invalid."} />
            </SimpleItem>
            <SimpleItem
              dataField={"resintRegNo"}
              editorType="dxTextBox"
              editorOptions={{
                showClearButton: true,
                mask: "000000-0000000",
                onValueChanged: onValueChanged,
              }}
            >
              {/* <Label text="주민등록번호" /> */}
              <Label text="Resident Registration Number" />
            </SimpleItem>
            <SimpleItem
              dataField={"dob"}
              editorType="dxDateBox"
              editorOptions={{
                readOnly: true,
                type: "date",
                displayFormat: "yyyy-MM-dd",
                dateSerializationFormat: "yyyy-MM-dd",
              }}
            >
              {/* <Label text="생일" /> */}
              <Label text="Birth Date" />
            </SimpleItem>
            <SimpleItem
              dataField={"sex"}
              editorType="dxSelectBox"
              editorOptions={{
                dataSource: sexList,
                valueExpr: "id",
                displayExpr: "name",
                showClearButton: true,
                onValueChanged: onSexValueChanged,
              }}
            >
              {/* <Label text="성별" /> */}
              <Label text="Gender" />
            </SimpleItem>
            <SimpleItem
              dataField={"maritalStatus"}
              editorType="dxSelectBox"
              editorOptions={{
                dataSource: maritalStatusList,
                valueExpr: "id",
                displayExpr: "name",
                showClearButton: true,
              }}
            >
              {/* <Label text="결혼여부" /> */}
              <Label text="Marital Status" />
            </SimpleItem>
          </GroupItem>
          <GroupItem caption="EMERGENCY INFO." colCount={4}>
            <ColCountByScreen sm={2} md={4} />
            <SimpleItem
              dataField={"emergCtcNetRelatsh"}
              editorType="dxTextBox"
              editorOptions={{
                showClearButton: true,
              }}
            >
              {/* <Label text="관계" /> */}
              <Label text="Relationship" />
            </SimpleItem>
            <SimpleItem
              dataField={"emergCtcNetName"}
              editorType="dxTextBox"
              editorOptions={{
                showClearButton: true,
              }}
            >
              {/* <Label text="성명" /> */}
              <Label text="Name" />
            </SimpleItem>
            <SimpleItem
              dataField={"emergCtcNetCtc"}
              editorType="dxTextBox"
              editorOptions={{
                showClearButton: true,
              }}
            >
              {/* <Label text="연락처" /> */}
              <Label text="Contact" />
            </SimpleItem>
          </GroupItem>
          {formDataSource && formDataSource.sex == 1 && (
            <GroupItem caption="MILITARY SERVICE" colCount={4}>
              <ColCountByScreen sm={2} md={4} />
              <SimpleItem
                dataField={"cmSvc"}
                editorType="dxSelectBox"
                editorOptions={{
                  dataSource: cmSvcList,
                  valueExpr: "id",
                  displayExpr: "name",
                  showClearButton: true,
                }}
              >
                {/* <Label text="군복무이수여부" /> */}
                <Label text="Military Service Completion Status" />
              </SimpleItem>
              <SimpleItem
                dataField={"militaryCat"}
                editorType="dxSelectBox"
                editorOptions={{
                  dataSource: militaryCatDataSource,
                  valueExpr: "id",
                  // displayExpr: "name",
                  displayExpr: displayMilitaryCatExpr,
                  showClearButton: true,
                  placeholder: "직접입력가능",
                  acceptCustomValue: true,
                  onCustomItemCreating: onCustomMilitaryCatItemCreating,
                }}
              >
                {/* <Label text="군별" /> */}
                <Label text="Military Branch" />
              </SimpleItem>
              {/* <SimpleItem dataField={"enlmtDate"} editorType="dxDateBox">
                <Label text="입대일" />
              </SimpleItem>
              <SimpleItem dataField={"dcDate"}>
                <Label text="전역일" />
              </SimpleItem> */}
              <SimpleItem>
                {/* <Label text="군복무기간" /> */}
                <Label text="Military Service Period" />
                <TwoDateBoxComponent
                  firstDateBox={{
                    placeholder: "Enlistment Date",
                    field: "enlmtDate",
                    max: new Date(),
                    value: formDataSource ? formDataSource.enlmtDate : null,
                  }}
                  secondDateBox={{
                    // placeholder: "전역일",
                    placeholder: "Discharge Date",
                    field: "dcDate",
                    max: new Date(),
                    value: formDataSource ? formDataSource.dcDate : null,
                  }}
                  setFormDataSource={setFormDataSource}
                />
              </SimpleItem>
              <SimpleItem
                dataField={"dcDiv"}
                editorType="dxSelectBox"
                editorOptions={{
                  dataSource: dcDivDataSource,
                  valueExpr: "id",
                  // displayExpr: "name",
                  displayExpr: displayDcDivExpr,
                  showClearButton: true,
                  placeholder: "직접입력가능",
                  acceptCustomValue: true,
                  onCustomItemCreating: onCustomDcDivItemCreating,
                }}
              >
                {/* <Label text="전역구분" /> */}
                <Label text="Discharge Type" />
              </SimpleItem>
            </GroupItem>
          )}
          <GroupItem colSpan={4}>
            <ButtonItem
              horizontalAlignment={"right"}
              buttonOptions={{
                text: "SAVE",
                type: "normal",
                stylingMode: "text",
                onClick: onClick,
              }}
            />
          </GroupItem>
        </Form>
      </Popup>
    </React.Fragment>
  );
}
